/**
 * answerChallenge — une réponse du défi éclair, envoyée au serveur sans que le jeu l'attende
 * (`api/activities/{id}/correction-wait/answers`) : il s'en sert pour ne plus reposer ce que l'élève
 * sait. Un échec ne change rien au jeu ; il part à la télémétrie (l'ancien l'avalait).
 */
import { activitiesService } from "../../../data/services/activitiesService"
import { createTelemetry } from "../../shared/telemetry"
import { type ApiChallengeQuestion } from "./correctionChallenge"

const telemetry = createTelemetry("activity.challenge", { role: "student" })

export function answerChallenge(activityId: number | null, question: ApiChallengeQuestion, index: number): void {
    if (activityId == null || question.id == null) return
    ;(
        activitiesService.answerCorrectionWait(
            { activityId },
            { quiz_question_id: question.id, answer: question.choices?.[index] }
        ) as Promise<unknown>
    ).catch((error: unknown) => {
        telemetry.error("answer", error)
    })
}
